// authentication
export const RESTORE_SESSION = 'authentication/RESTORE_SESSION';
export const RESTORE_SESSION_SUCCESS = 'authentication/RESTORE_SESSION_SUCCESS';
export const RESTORE_SESSION_FAIL = 'authentication/RESTORE_SESSION_FAIL';
export const START_ONE_CENT_IDENTIFICATION = 'authentication/START_ONE_CENT_IDENTIFICATION';
export const START_ONE_CENT_IDENTIFICATION_SUCCESS = 'authentication/START_ONE_CENT_IDENTIFICATION_SUCCESS';
export const START_ONE_CENT_IDENTIFICATION_FAIL = 'authentication/START_ONE_CENT_IDENTIFICATION_FAIL';
export const BANK_LOGIN_START = 'authentication/BANK_LOGIN_START';
export const BANK_LOGIN_START_SUCCESS = 'authentication/BANK_LOGIN_START_SUCCESS';
export const BANK_LOGIN_START_FAIL = 'authentication/BANK_LOGIN_START_FAIL';
export const GET_OTP_START = 'authentication/GET_OTP_START';
export const GET_OTP_START_SUCCESS = 'authentication/GET_OTP_START_SUCCESS';
export const GET_OTP_START_FAIL = 'authentication/FI_GET_OTP_START_FAIL';
export const FI_SIGNUP_CONFIRM_START = 'authentication/FI_SIGNUP_CONFIRM_START';
export const FI_SIGNUP_CONFIRM_START_SUCCESS = 'authentication/FI_SIGNUP_CONFIRM_START_SUCCESS';
export const FI_SIGNUP_CONFIRM_START_FAIL = 'authentication/FI_SIGNUP_CONFORM_START_FAIL';
export const MOBILE_ID_START = 'authentication/MOBILE_ID_START';
export const MOBILE_ID_START_SUCCESS = 'authentication/MOBILE_ID_START_SUCCESS';
export const MOBILE_ID_START_FAIL = 'authentication/MOBILE_ID_START_FAIL';
export const MOBILE_ID_VERIFY = 'authentication/MOBILE_ID_VERIFY';
export const MOBILE_ID_VERIFY_SUCCESS = 'authentication/MOBILE_ID_VERIFY_SUCCESS';
export const MOBILE_ID_VERIFY_FAIL = 'authentication/MOBILE_ID_VERIFY_FAIL';
export const SMART_ID_START = 'authentication/SMART_ID_START';
export const SMART_ID_START_SUCCESS = 'authentication/SMART_ID_START_SUCCESS';
export const SMART_ID_START_FAIL = 'authentication/SMART_ID_START_FAIL';
export const SMART_ID_STATUS = 'authentication/SMART_ID_STATUS';
export const SMART_ID_STATUS_SUCCESS = 'authentication/SMART_ID_STATUS_SUCCESS';
export const SMART_ID_STATUS_FAIL = 'authentication/SMART_ID_STATUS_FAIL';
export const TOGGLE_AUTH_METHOD = 'authentication/TOGGLE_AUTH_METHOD';
export const MIGRATED_USER_PASSWORD_RECOVERY_LT = 'authentication/MIGRATED_USER_PASSWORD_RECOVERY_LT';
export const SET_APPLY_GUARANTOR = 'authentication/SET_APPLY_GUARANTOR';
export const LOGIN = 'authentication/LOGIN';
export const LOGIN_SUCCESS = 'authentication/LOGIN_SUCCESS';
export const LOGIN_FAIL = 'authentication/LOGIN_FAIL';
export const REGISTER_MX = 'authentication/REGISTER_MX';
export const REGISTER_MX_SUCCESS = 'authentication/REGISTER_MX_SUCCESS';
export const REGISTER_MX_FAIL = 'authentication/REGISTER_MX_FAIL';
export const REGISTER_CZ = 'authentication/REGISTER_CZ';
export const REGISTER_CZ_SUCCESS = 'authentication/REGISTER_CZ_SUCCESS';
export const REGISTER_CZ_FAIL = 'authentication/REGISTER_CZ_FAIL';
export const REGISTER_LT = 'authentication/REGISTER_LT';
export const REGISTER_PL = 'authentication/REGISTER_PL';
export const REGISTER_PL_SUCCESS = 'authentication/REGISTER_PL_SUCCESS';
export const REGISTER_PL_FAIL = 'authentication/REGISTER_PL_FAIL';
export const SIGNUP_START = 'authentication/SIGNUP_START';
export const SIGNUP_START_SUCCESS = 'authentication/SIGNUP_START_SUCCESS';
export const SIGNUP_START_FAIL = 'authentication/SIGNUP_START_FAIL';
export const SIGNUP_CONFIRM = 'authentication/SIGNUP_CONFIRM';
export const SIGNUP_CONFIRM_SUCCESS = 'authentication/SIGNUP_CONFIRM_SUCCESS';
export const SIGNUP_CONFIRM_FAIL = 'authentication/SIGNUP_CONFIRM_FAIL';
export const REGISTER_ES = 'authentication/REGISTER_ES';
export const REGISTER_ES_SUCCESS = 'authentication/REGISTER_ES_SUCCESS';
export const REGISTER_ES_FAIL = 'authentication/REGISTER_ES_FAIL';
export const POST_REGISTRATION_DETAILS = 'loan/POST_REGISTRATION_DETAILS';
export const POST_REGISTRATION_DETAILS_SUCCESS = 'loan/POST_REGISTRATION_DETAILS_SUCCESS';
export const POST_REGISTRATION_DETAILS_FAIL = 'loan/POST_REGISTRATION_DETAILS_FAIL';
export const PUT_ADDITIONAL_CONSENT = 'loan/PUT_ADDITIONAL_CONSENT';
export const PUT_ADDITIONAL_CONSENT_SUCCESS = 'loan/PUT_ADDITIONAL_CONSENT_SUCCESS';
export const PUT_ADDITIONAL_CONSENT_FAIL = 'loan/PUT_ADDITIONAL_CONSENT_FAIL';
export const PUT_MISSING_ADDITIONAL_CONSENT = 'loan/PUT_MISSING_ADDITIONAL_CONSENT';
export const PUT_MISSING_ADDITIONAL_CONSENT_SUCCESS = 'loan/PUT_MISSING_ADDITIONAL_CONSENT_SUCCESS';
export const PUT_MISSING_ADDITIONAL_CONSENT_FAIL = 'loan/PUT_MISSING_ADDITIONAL_CONSENT_FAIL';
export const SIGNUP_COMPLETE = 'loan/SIGNUP_COMPLETE';
export const SIGNUP_COMPLETE_SUCCESS = 'loan/SIGNUP_COMPLETE_SUCCESS';
export const SIGNUP_COMPLETE_FAIL = 'loan/SIGNUP_COMPLETE_FAIL';
export const SIGNUP_IMPERSONATION_COMPLETE = 'loan/SIGNUP_IMPERSONATION_COMPLETE';
export const SIGNUP_IMPERSONATION_COMPLETE_SUCCESS = 'loan/SIGNUP_IMPERSONATION_COMPLETE_SUCCESS';
export const SIGNUP_IMPERSONATION_COMPLETE_FAIL = 'loan/SIGNUP_IMPERSONATION_COMPLETE_FAIL';
export const LOGOUT = 'authentication/LOGOUT';
export const LOGOUT_SUCCESS = 'authentication/LOGOUT_SUCCESS';
export const LOGOUT_FAIL = 'authentication/LOGOUT_FAIL';
export const CUSTOMER_REDIRECT = 'authentication/CUSTOMER_REDIRECT';
export const ERROR_MESSAGE = 'authentication/ERROR_MESSAGE';
export const GET_CONTRACTS_SUCCESS = 'authentication/GET_CONTRACT_SUCCESS';
export const GET_CONTRACTS_FAIL = 'authentication/GET_CONTRACT_FAIL';
export const GET_REGISTER_DATA = 'authentication/GET_REGISTER_DATA';
export const GET_REGISTER_DATA_SUCCESS = 'authentication/GET_REGISTER_DATA_SUCCESS';
export const GET_REGISTER_DATA_FAIL = 'authentication/GET_REGISTER_DATA_FAIL';
export const GET_NEW_PASSWORD = 'authentication/GET_NEW_PASSWORD';
export const CANCEL_GET_NEW_PASSWORD = 'authentication/CANCEL_GET_NEW_PASSWORD';
export const SEND_NEW_PASSWORD = 'authentication/SEND_NEW_PASSWORD';
export const SEND_NEW_PASSWORD_SUCCESS = 'authentication/SEND_NEW_PASSWORD_SUCCESS';
export const SEND_NEW_PASSWORD_FAIL = 'authentication/SEND_NEW_PASSWORD_FAIL';
export const CANCEL_TEMPORARY_PASSWORD_LOGIN = 'authentication/CANCEL_TEMPORARY_PASSWORD_LOGIN';
export const CHANGE_PASSWORD = 'authentication/CHANGE_PASSWORD';
export const CHANGE_PASSWORD_SUCCESS = 'authentication/CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_COMPLETED = 'authentication/CHANGE_PASSWORD_COMPLETED';
export const CHANGE_PASSWORD_FAIL = 'authentication/CHANGE_PASSWORD_FAIL';
export const INIT_PASSWORD_RECOVERY = 'authentication/INIT_PASSWORD_RECOVERY';
export const INIT_PASSWORD_RECOVERY_SUCCESS = 'authentication/INIT_PASSWORD_RECOVERY_SUCCESS';
export const INIT_PASSWORD_RECOVERY_FAIL = 'authentication/INIT_PASSWORD_RECOVERY_FAIL';
export const TOGGLE_RECOVERY_PASSWORD = 'authentication/TOGGLE_RECOVERY_PASSWORD';
export const CANCEL_PASSWORD_RECOVERY = 'authentication/CANCEL_PASSWORD_RECOVERY';
export const MAKE_USER_CHANGING_PASSWORD = 'authentication/MAKE_USER_CHANGING_PASSWORD';
export const PASSWORD_LINK_RECOVERY_NAVIGATE_BACK = 'authentication/PASSWORD_LINK_RECOVERY_NAVIGATE_BACK';
export const TMX_INIT = 'authentication/TMX_INIT';
export const TMX_INIT_SUCCESS = 'authentication/TMX_INIT_SUCCESS';
export const TMX_INIT_FAIL = 'authentication/TMX_INIT_FAIL';
export const SAVE_SIGN_UP_DATA = 'authentication/SAVE_SIGN_UP_DATA';
export const FINISH_SIGNUP_START = 'authentication/FINISH_SIGNUP_START';
export const CLEAR_SIGN_UP_GATE = 'authentication/CLEAR_SIGN_UP_GATE';
export const GET_BANKS_LIST_LT = 'authentication/GET_BANKS_LIST_LT';
export const GET_BANKS_LIST_LT_SUCCESS = 'authentication/GET_BANKS_LIST_LT_SUCCESS';
export const GET_BANKS_LIST_LT_FAIL = 'authentication/GET_BANKS_LIST_LT_FAIL';
export const GET_LOCAL_TIME = 'authentication/GET_LOCAL_TIME';
export const GET_LOCAL_TIME_SUCCESS = 'authentication/GET_LOCAL_TIME_SUCCESS';
export const GET_LOCAL_TIME_FAIL = 'authentication/GET_LOCAL_TIME_FAIL';
export const IMPERSONATION = 'authentication/IMPERSONATION';
export const IMPERSONATION_SUCCESS = 'authentication/IMPERSONATION_SUCCESS';
export const IMPERSONATION_FAIL = 'authentication/IMPERSONATION_FAIL';
export const OCM_STATUS = 'authentication/OCM_STATUS';
export const OCM_STATUS_SUCCESS = 'authentication/OCM_STATUS_SUCCESS';
export const OCM_STATUS_FAIL = 'authentication/OCM_STATUS_FAIL';
export const SET_MW_TOKEN = 'authentication/SET_MW_TOKEN';
export const CHECK_MW_TOKEN = 'authentication/CHECK_MW_TOKEN';
export const CHECK_MW_TOKEN_SUCCESS = 'authentication/CHECK_MW_TOKEN_SUCCESS';
export const CHECK_MW_TOKEN_FAIL = 'authentication/CHECK_MW_TOKEN_FAIL';
export const SET_CPL_TRIGGERED = 'authentication/SET_CPL_TRIGGERED';
export const DELETE_SHOULD_REPORT_AUTH_EVENT = 'authentication/DELETE_SHOULD_REPORT_AUTH_EVENT';
export const PUT_CUSTOMER_EMAIL = 'authentication/PUT_CUSTOMER_EMAIL';
export const PUT_CUSTOMER_EMAIL_SUCCESS = 'authentication/PUT_CUSTOMER_EMAIL_SUCCESS';
export const PUT_CUSTOMER_EMAIL_FAIL = 'authentication/PUT_CUSTOMER_EMAIL_FAIL';
export const RESET_BANK_LOGIN = 'authentication/RESET_BANK_LOGIN';
export const SET_REGISTRATION_STEP = 'authentication/SET_REGISTRATION_STEP';
export const SET_BANK_PAYMENT_BUTTON_CLICKED = 'authentication/SET_BANK_PAYMENT_BUTTON_CLICKED';
export const SHOW_I_PAID_BUTTON = 'authentication/SHOW_I_PAID_BUTTON';
export const SET_SELF_SERVICE_IMPERSONATION = 'authentication/SET_SELF_SERVICE_IMPERSONATION';
export const UNSET_SELF_SERVICE_IMPERSONATION = 'authentication/UNSET_SELF_SERVICE_IMPERSONATION';
export const SET_EXPIRED_PAGE = 'authentication/SET_EXPIRED_PAGE';
export const SET_CONFIRMATION_KEY = 'authentication/SET_CONFIRMATION_KEY';
export const SET_IMPERSONATION_KEY = 'authentication/SET_IMPERSONATION_KEY';
export const SET_BROKER_URL = 'authentication/SET_BROKER_URL';
export const RESET_LOGIN_FLAG = 'authentication/RESET_LOGIN_FLAG';

export const GET_REIDENTIFY_OTP_START = 'authentication/GET_REIDENTIFY_OTP_START';
export const GET_REIDENTIFY_OTP_START_SUCCESS = 'authentication/GET_REIDENTIFY_OTP_START_SUCCESS';
export const GET_REIDENTIFY_OTP_START_FAIL = 'authentication/FI_GET_REIDENTIFY_OTP_START_FAIL';

export const CHECK_EMAIL_VERIFICATION_STATUS = 'authentication/CHECK_EMAIL_VERIFICATION_STATUS';
export const CHECK_EMAIL_VERIFICATION_STATUS_SUCCESS = 'authentication/CHECK_EMAIL_VERIFICATION_STATUS_SUCCESS';
export const CHECK_EMAIL_VERIFICATION_STATUS_FAIL = 'authentication/CHECK_EMAIL_VERIFICATION_STATUS_FAIL';
export const SEND_CONFIRMATION_EMAIL = 'authentication/SEND_CONFIRMATION_EMAIL';
export const SEND_CONFIRMATION_EMAIL_SUCCESS = 'authentication/SEND_CONFIRMATION_EMAIL_SUCCESS';
export const SEND_CONFIRMATION_EMAIL_FAIL = 'authentication/SEND_CONFIRMATION_EMAIL_FAIL';

// localization
export const CHANGE_LANGUAGE = 'localization/CHANGE_LANGUAGE';
export const GET_TRANSLATIONS = 'localization/GET_TRANSLATIONS';
export const GET_TRANSLATIONS_SUCCESS = 'localization/GET_TRANSLATIONS_SUCCESS';
export const GET_TRANSLATIONS_FAIL = 'localization/GET_TRANSLATIONS_FAIL';

// loan
export const GET_PSYCHOMETRIC_URL = 'loan/GET_PSYCHOMETRIC_URL';
export const GET_PSYCHOMETRIC_URL_SUCCESS = 'loan/GET_PSYCHOMETRIC_URL_SUCCESS';
export const GET_PSYCHOMETRIC_URL_FAIL = 'loan/GET_PSYCHOMETRIC_URL_FAIL';
export const RESET = 'loan/RESET';
export const RESTORE = 'loan/RESTORE_FORM_DATA';
export const SAVE_LOAN_STATE = 'loan/SAVE_LOAN_STATE';
export const STEP_BACK = 'loan/STEP_BACK';
export const STEP_FORWARD = 'loan/STEP_FORWARD';
export const SET_STEP = 'loan/SET_STEP';
export const SET_PRINCIPAL = 'loan/SET_PRINCIPAL';
export const SET_MATURITY_PERIODS = 'loan/SET_MATURITY_PERIODS';
export const GET_MMPS_BY_GROUP = 'loan/GET_MMPS_BY_GROUP';
export const GET_MMPS_BY_GROUP_SUCCESS = 'loan/GET_MMPS_BY_GROUP_SUCCESS';
export const GET_MMPS_BY_GROUP_FAIL = 'loan/GET_MMPS_BY_GROUP_FAIL';
export const GET_MMPS_BY_MONTH = 'loan/GET_MMPS_BY_MONTH';
export const GET_MMPS_BY_MONTH_SUCCESS = 'loan/GET_MMPS_BY_MONTH_SUCCESS';
export const GET_MMPS_BY_MONTH_FAIL = 'loan/GET_MMPS_BY_MONTH_FAIL';
export const GET_ALL_MMPS_BY_MONTH = 'loan/GET_ALL_MMPS_BY_MONTH';
export const GET_ALL_MMPS_BY_MONTH_SUCCESS = 'loan/GET_ALL_MMPS_BY_MONTH_SUCCESS';
export const GET_ALL_MMPS_BY_MONTH_FAIL = 'loan/GET_ALL_MMPS_BY_MONTH_FAIL';
export const GET_IL_PRODUCTS = 'loan/GET_IL_PRODUCTS';
export const GET_IL_PRODUCTS_SUCCESS = 'loan/GET_IL_PRODUCTS_SUCCESS';
export const GET_IL_PRODUCTS_FAIL = 'loan/GET_IL_PRODUCTS_FAIL';
export const GET_CONTRACT_INTEREST_VALUE = 'loan/GET_CONTRACT_INTEREST_VALUE';
export const GET_CONTRACT_INTEREST_VALUE_SUCCESS = 'loan/GET_CONTRACT_INTEREST_VALUE_SUCCESS';
export const GET_CONTRACT_INTEREST_VALUE_FAIL = 'loan/GET_CONTRACT_INTEREST_VALUE_FAIL';
export const INIT_LOAN = 'loan/INIT_LOAN';
export const INIT_LOAN_SUCCESS = 'loan/INIT_LOAN_SUCCESS';
export const INIT_LOAN_FAIL = 'loan/INIT_LOAN_FAIL';
export const PUT_CUSTOMER = 'loan/PUT_CUSTOMER';
export const PUT_CUSTOMER_SUCCESS = 'loan/PUT_CUSTOMER_SUCCESS';
export const PUT_CUSTOMER_FAIL = 'loan/PUT_CUSTOMER_FAIL';
export const PUT_CUSTOMER_MX_BANK_ACCOUNT_VERIFICATION = 'loan/PUT_CUSTOMER_MX_BANK_ACCOUNT_VERIFICATION';
export const PUT_CUSTOMER_MX_BANK_ACCOUNT_VERIFICATION_SUCCESS = 'loan/PUT_CUSTOMER_MX_BANK_ACCOUNT_VERIFICATION_SUCCESS';
export const PUT_CUSTOMER_MX_BANK_ACCOUNT_VERIFICATION_FAIL = 'loan/PUT_CUSTOMER_MX_BANK_ACCOUNT_VERIFICATION_FAIL';
export const PUT_CUSTOMER_MX_NAMES = 'loan/PUT_CUSTOMER_MX_NAMES';
export const PUT_CUSTOMER_ES_NAMES = 'loan/PUT_CUSTOMER_ES_NAMES';
export const PUT_CUSTOMER_BIRTH_DETAILS = 'loan/PUT_CUSTOMER_BIRTH_DETAILS';
export const PUT_CUSTOMER_ES_ADDRESS = 'loan/PUT_CUSTOMER_ES_ADDRESS';
export const PUT_INFO_CREDITEA = 'loan/PUT_INFO_CREDITEA';
export const PUT_INFO_CREDITEA_SUCCESS = 'loan/PUT_INFO_CREDITEA_SUCCESS';
export const PUT_INFO_CREDITEA_FAIL = 'loan/PUT_INFO_CREDITEA_FAIL';
export const PUT_SCREEN_NAME = 'loan/PUT_SCREEN_NAME';
export const PUT_SCREEN_NAME_SUCCESS = 'loan/PUT_SCREEN_NAME_SUCCESS';
export const PUT_SCREEN_NAME_FAIL = 'loan/PUT_SCREEN_NAME_FAIL';
export const PUT_SCREEN_NAME_AFTER_EDUCATION_LT = 'loan/PUT_SCREEN_NAME_AFTER_EDUCATION_LT';
export const PUT_SCREEN_NAME_SUCCESS_AFTER_EDUCATION_LT = 'loan/PUT_SCREEN_NAME_SUCCESS_AFTER_EDUCATION_LT';
export const PUT_SCREEN_NAME_FAIL_AFTER_EDUCATION_LT = 'loan/PUT_SCREEN_NAME_FAIL_AFTER_EDUCATION_LT';
export const OBLIGATIONS = 'loan/OBLIGATIONS';
export const PUT_BANK_ACCOUNT = 'loan/PUT_BANK_ACCOUNT';
export const PUT_BANK_ACCOUNT_SUCCESS = 'loan/PUT_BANK_ACCOUNT_SUCCESS';
export const PUT_BANK_ACCOUNT_FAIL = 'loan/PUT_BANK_ACCOUNT_FAIL';
export const PUT_MARITAL_STATUS_PL = 'loan/PUT_MARITAL_STATUS_PL';
export const PUT_MARITAL_STATUS_PL_SUCCESS = 'loan/PUT_MARITAL_STATUS_PL_SUCCESS';
export const PUT_MARITAL_STATUS_PL_FAIL = 'loan/PUT_BANK_ACCOUNT_FAIL';
export const PUT_ADDRESS = 'loan/PUT_ADDRESS';
export const ADDRESS_AU = 'loan/ADDRESS_AU';
export const ADDRESS_AU_SUCCESS = 'loan/ADDRESS_AU_SUCCESS';
export const ADDRESS_AU_FAIL = 'loan/ADDRESS_AU_FAIL';
export const PUT_ADDRESS_SUCCESS = 'loan/PUT_ADDRESS_SUCCESS';
export const PUT_ADDRESS_FAIL = 'loan/PUT_ADDRESS_FAIL';
export const PUT_LOAN_PURPOSE = 'loan/PUT_LOAN_PURPOSE';
export const PUT_LOAN_PURPOSE_SUCCESS = 'loan/PUT_LOAN_PURPOSE_SUCCESS';
export const PUT_LOAN_PURPOSE_FAIL = 'loan/PUT_ADDRESS_FAIL';
export const INCOME = 'loan/INCOME';
export const EXPENSES = 'loan/EXPENSES';
export const LOANS = 'loan/LOANS';
export const LOAN_EXPENSES = 'loan/LOAN_EXPENSES'; // for Latvia
export const MARITAL_STATUS = 'loan/MARITAL_STATUS';
export const EDUCATION = 'loan/EDUCATION';
export const PUT_ADDRESS_INFO = 'loan/PUT_ADDRESS_INFO';
export const PUT_ADDRESS_INFO_SUCCESS = 'loan/PUT_ADDRESS_INFO_SUCCESS';
export const PUT_ADDRESS_INFO_FAIL = 'loan/PUT_ADDRESS_INFO_FAIL';
export const EDUCATION_LT = 'loan/EDUCATION_LT';
export const EDUCATION_LT_SUCCESS = 'loan/EDUCATION_LT_SUCCESS';
export const EDUCATION_LT_FAIL = 'loan/EDUCATION_LT_FAIL';
export const PUT_EDUCATION_INFO = 'loan/PUT_EDUCATION_INFO';
export const PUT_EDUCATION_INFO_SUCCESS = 'loan/PUT_EDUCATION_INFO_SUCCESS';
export const PUT_EDUCATION_INFO_FAIL = 'loan/PUT_EDUCATION_INFO_FAIL';
export const START_CUSTOMER_IDENTIFICATION = 'loan/START_CUSTOMER_IDENTIFICATION';
export const START_CUSTOMER_IDENTIFICATION_SUCCESS = 'loan/START_CUSTOMER_IDENTIFICATION_SUCCESS';
export const START_CUSTOMER_IDENTIFICATION_FAIL = 'loan/START_CUSTOMER_IDENTIFICATION_FAIL';
export const NATIONALITY_LT = 'loan/NATIONALITY_LT';
export const NATIONALITY_LT_SUCCESS = 'loan/NATIONALITY_LT_SUCCESS';
export const NATIONALITY_LT_FAIL = 'loan/NATIONALITY_LT_FAIL';
export const WORK_STATUS = 'loan/WORK_STATUS';
export const EDUCATION_WORK = 'loan/EDUCATION_WORK';
export const EDUCATION_WORK_SUCCESS = 'loan/EDUCATION_WORK_SUCCESS';
export const EDUCATION_WORK_FAIL = 'loan/EDUCATION_WORK_FAIL';
export const EDUCATION_WORK_CREDITEA = 'loan/EDUCATION_WORK_CREDITEA';
export const REGISTRIES_LT = 'loan/REGISTRIES_LT';
export const PUT_EDUCATION_WORK_MX = 'loan/PUT_EDUCATION_WORK_MX';
export const PUT_EDUCATION_WORK_MX_SUCCESS = 'loan/PUT_EDUCATION_WORK_MX_SUCCESS';
export const PUT_EDUCATION_WORK_MX_FAIL = 'loan/PUT_EDUCATION_WORK_MX_FAIL';
export const RESIDENCE = 'loan/RESIDENCE';
export const HOUSEHOLD_CHILDREN = 'loan/HOUSEHOLD_CHILDREN';
export const FAMILY_AU = 'loan/FAMILY_AU';
export const FAMILY_AU_SUCCESS = 'loan/FAMILY_AU_SUCCESS';
export const FAMILY_AU_FAIL = 'loan/FAMILY_AU_FAIL';
export const FAMILY_CREDITEA = 'loan/FAMILY_CREDITEA';
export const PUT_FAMILY_MX = 'loan/PUT_FAMILY_MX';
export const PUT_FAMILY_MX_SUCCESS = 'loan/PUT_FAMILY_MX_SUCCESS';
export const PUT_FAMILY_MX_FAIL = 'loan/PUT_FAMILY_MX_FAIL';
export const PUT_FAMILY_CREDITEA = 'loan/PUT_FAMILY_CREDITEA';
export const PUT_FAMILY_CREDITEA_SUCCESS = 'loan/PUT_FAMILY_CREDITEA_SUCCESS';
export const PUT_FAMILY_CREDITEA_FAIL = 'loan/PUT_FAMILY_CREDITEA_FAIL';
export const LOAN_QUESTIONS = 'loan/LOAN_QUESTIONS';
export const BANK_NAME = 'loan/BANK_NAME';
export const PUT_REFERENCE = 'loan/PUT_REFERENCE';
export const PUT_REFERENCE_SUCCESS = 'loan/PUT_REFERENCE_SUCCESS';
export const PUT_REFERENCE_FAIL = 'loan/PUT_REFERENCE_FAIL';
export const PUT_FINANCIAL = 'loan/PUT_FINANCIAL';
export const PUT_FINANCIAL_SUCCESS = 'loan/PUT_FINANCIAL_SUCCESS';
export const PUT_FINANCIAL_FAIL = 'loan/PUT_FINANCIAL_FAIL';
export const PUT_PAYMENT_DAY = 'loan/PUT_PAYMENT_DAY';
export const PUT_PAYMENT_DAY_SUCCESS = 'loan/PUT_PAYMENT_DAY_SUCCESS';
export const PUT_PAYMENT_DAY_FAIL = 'loan/PUT_PAYMENT_DAY_FAIL';
export const GET_POST_OFFICES = 'loan/GET_POST_OFFICES';
export const GET_POST_OFFICES_SUCCESS = 'loan/GET_POST_OFFICES_SUCCESS';
export const GET_POST_OFFICES_FAIL = 'loan/GET_POST_OFFICES_FAIL';
export const GET_LOAN_ISSUERS = 'loan/GET_LOAN_ISSUERS';
export const GET_LOAN_ISSUERS_SUCCESS = 'loan/GET_LOAN_ISSUERS_SUCCESS';
export const GET_LOAN_ISSUERS_FAIL = 'loan/GET_LOAN_ISSUERS_FAIL';
export const GET_PAYMENT_PLAN = 'loan/GET_PAYMENT_PLAN';
export const GET_PAYMENT_PLAN_SUCCESS = 'loan/GET_PAYMENT_PLAN_SUCCESS';
export const GET_PAYMENT_PLAN_FAIL = 'loan/GET_PAYMENT_PLAN_FAIL';
export const GET_REGISTRATION_STATUS = 'loan/GET_REGISTRATION_STATUS';
export const GET_REGISTRATION_STATUS_SUCCESS = 'loan/GET_REGISTRATION_STATUS_SUCCESS';
export const GET_REGISTRATION_STATUS_FAIL = 'loan/GET_REGISTRATION_STATUS_FAIL';
export const START_BLUEMEDIA = 'loan/START_BLUEMEDIA';
export const START_BLUEMEDIA_SUCCESS = 'loan/START_BLUEMEDIA_SUCCESS';
export const START_BLUEMEDIA_FAIL = 'loan/START_BLUEMEDIA_FAIL';
export const GET_APPLICABLE_CAMPAIGNS = 'loan/GET_APPLICABLE_CAMPAIGNS';
export const GET_APPLICABLE_CAMPAIGNS_SUCCESS = 'loan/GET_APPLICABLE_CAMPAIGNS_SUCCESS';
export const GET_APPLICABLE_CAMPAIGNS_FAIL = 'loan/GET_APPLICABLE_CAMPAIGNS_FAIL';
export const GET_DATE_RANGE = 'loan/GET_DATE_RANGE';
export const GET_DATE_RANGE_SUCCESS = 'loan/GET_DATE_RANGE_SUCCESS';
export const GET_DATE_RANGE_FAIL = 'loan/GET_DATE_RANGE_FAIL';
export const GET_MMP_BY_DUE_DATE = 'loan/GET_MMP_BY_DUE_DATE';
export const GET_MMP_BY_DUE_DATE_SUCCESS = 'loan/GET_MMP_BY_DUE_DATE_SUCCESS';
export const GET_MMP_BY_DUE_DATE_FAIL = 'loan/GET_MMP_BY_DUE_DATE_FAIL';
export const PUT_POST_OFFICE = 'loan/PUT_POST_OFFICE';
export const PUT_POST_OFFICE_SUCCESS = 'loan/PUT_POST_OFFICE_SUCCESS';
export const PUT_POST_OFFICE_FAIL = 'loan/PUT_POST_OFFICE_FAIL';
export const SET_MX_ADDRESS = 'loan/SET_MX_ADDRESS';
export const GET_MX_ADDRESS = 'loan/GET_MX_ADDRESS';
export const GET_MX_ADDRESS_SUCCESS = 'loan/GET_MX_ADDRESS_SUCCESS';
export const GET_MX_ADDRESS_FAIL = 'loan/GET_MX_ADDRESS_FAIL';
export const SET_SELECTED_PRODUCT = 'loan/SET_SELECTED_PRODUCT';
export const GET_PRODUCTS = 'loan/GET_PRODUCTS';
export const GET_PRODUCTS_SUCCESS = 'loan/GET_PRODUCTS_SUCCESS';
export const GET_PRODUCTS_FAIL = 'loan/GET_PRODUCTS_FAIL';
export const GET_PRODUCTS_FOR_CREDIT_LIMIT = 'loan/GET_PRODUCTS_FOR_CREDIT_LIMIT';
export const GET_PRODUCTS_FOR_CREDIT_LIMIT_SUCCESS = 'loan/GET_PRODUCTS_FOR_CREDIT_LIMIT_SUCCESS';
export const GET_PRODUCTS_FOR_CREDIT_LIMIT_FAIL = 'loan/GET_PRODUCTS_FOR_CREDIT_LIMIT_FAIL';
export const GET_INSTALLMENT = 'loan/GET_INSTALLMENT';
export const GET_INSTALLMENT_SUCCESS = 'loan/GET_INSTALLMENT_SUCCESS';
export const GET_INSTALLMENT_FAIL = 'loan/GET_INSTALLMENT_FAIL';
export const CHOOSE_PRODUCT = 'loan/CHOOSE_PRODUCT';
export const PUT_PRODUCT = 'loan/PUT_PRODUCT';
export const PUT_PRODUCT_SUCCESS = 'loan/PUT_PRODUCT_SUCCESS';
export const PUT_PRODUCT_FAIL = 'loan/PUT_PRODUCT_FAIL';
export const PUT_CHANGE_PRODUCT = 'loan/PUT_CHANGE_PRODUCT';
export const PUT_CHANGE_PRODUCT_SUCCESS = 'loan/PUT_CHANGE_PRODUCT_SUCCESS';
export const PUT_CHANGE_PRODUCT_FAIL = 'loan/PUT_CHANGE_PRODUCT_FAIL';
export const PATCH_GUARANTOR_THEN_FEES_ES = 'loan/PATCH_GUARANTOR_THEN_FEES_ES';
export const PATCH_GUARANTOR_THEN_FEES_ES_SUCCESS = 'loan/PATCH_GUARANTOR_THEN_FEES_ES_SUCCESS';
export const PATCH_GUARANTOR_THEN_FEES_ES_FAIL = 'loan/PATCH_GUARANTOR_THEN_FEES_ES_FAIL';
export const PUT_HYBRID_PRODUCT = 'loan/PUT_HYBRID_PRODUCT';
export const PUT_HYBRID_PRODUCT_SUCCESS = 'loan/PUT_HYBRID_PRODUCT_SUCCESS';
export const PUT_HYBRID_PRODUCT_FAIL = 'loan/PUT_HYBRID_PRODUCT_FAIL';
export const SUBMIT = 'loan/SUBMIT';
export const SUBMIT_SUCCESS = 'loan/SUBMIT_SUCCESS';
export const SUBMIT_FAIL = 'loan/SUBMIT_FAIL';
export const PUT_CREDENTIALS = 'loan/PUT_CREDENTIALS';
export const PUT_CREDENTIALS_SUCCESS = 'loan/PUT_CREDENTIALS_SUCCESS';
export const PUT_CREDENTIALS_FAIL = 'loan/PUT_CREDENTIALS_FAIL';
export const VERIFY = 'loan/VERIFY';
export const PL_VERIFY = 'loan/PL_VERIFY';
export const PUSH_GA_STEP = 'loan/PUSH_GA_STEP';
export const INSTANTOR = 'loan/INSTANTOR';
export const INSTANTOR_SUCCESS = 'loan/INSTANTOR_SUCCESS';
export const INSTANTOR_FAILED = 'loan/INSTANTOR_FAILED';
export const ONE_CENT = 'loan/ONE_CENT';
export const LOANSUBMITTED = 'loan/LOANSUBMITTED';
export const TRIGGER_EMAIL = 'loan/TRIGGER_EMAIL';
export const TRIGGER_EMAIL_SUCCESS = 'loan/TRIGGER_EMAIL_SUCCESS';
export const TRIGGER_EMAIL_FAIL = 'loan/TRIGGER_EMAIL_FAIL';
export const PUSH_GA_PURCHASE = 'loan/PUSH_GA_PURCHASE';
export const BACK_TO_INCOME = 'loan/BACK_TO_INCOME';
export const BACK_TO_VERIFICATION = 'loan/BACK_TO_VERIFICATION';
export const GET_COUNTRY_LIST = 'loan/GET_COUNTRY_LIST';
export const GET_COUNTRY_LIST_SUCCESS = 'loan/GET_COUNTRY_LIST_SUCCESS';
export const GET_COUNTRY_LIST_FAIL = 'loan/GET_COUNTRY_LIST_FAIL';
export const GET_ADDRESS_SUGGESTIONS = 'loan/GET_ADDRESS_SUGGESTIONS';
export const GET_ADDRESS_SUGGESTIONS_SUCCESS = 'loan/GET_ADDRESS_SUGGESTIONS_SUCCESS';
export const GET_ADDRESS_SUGGESTIONS_FAIL = 'loan/GET_ADDRESS_SUGGESTIONS_FAIL';
export const POST_EID_AUTHORIZATION_TOKEN = 'loan/POST_EID_AUTHORIZATION_TOKEN';
export const POST_EID_AUTHORIZATION_TOKEN_SUCCESS = 'loan/POST_EID_AUTHORIZATION_TOKEN_SUCCESS';
export const POST_EID_AUTHORIZATION_TOKEN_FAIL = 'loan/POST_EID_AUTHORIZATION_TOKEN_FAIL';
export const POST_ONFIDO_AUTHORIZATION = 'loan/POST_ONFIDO_AUTHORIZATION';
export const POST_ONFIDO_AUTHORIZATION_SUCCESS = 'loan/POST_ONFIDO_AUTHORIZATION_SUCCESS';
export const POST_ONFIDO_AUTHORIZATION_FAIL = 'loan/POST_ONFIDO_AUTHORIZATION_FAIL';
export const POST_ONFIDO_CHECK = 'loan/POST_ONFIDO_CHECK';
export const POST_ONFIDO_CHECK_SUCCESS = 'loan/POST_ONFIDO_CHECK_SUCCESS';
export const POST_ONFIDO_SKIPPED = 'loan/POST_ONFIDO_SKIPPED';
export const POST_ONFIDO_CHECK_FAIL = 'loan/POST_ONFIDO_CHECK_FAIL';
export const KONTOMATIK = 'loan/KONTOMATIK';
export const VERIFICATION = 'loan/VERIFICATION';
export const EID_INTRO = 'loan/EID_INTRO';
export const SAVE_EID_RESULT = 'loan/SAVE_EID_RESULT';
export const SAVE_EID_RESULT_SUCCESS = 'loan/SAVE_EID_RESULT_SUCCESS';
export const SAVE_EID_RESULT_FAIL = 'loan/SAVE_EID_RESULT_FAIL';
export const PUT_KONTOMATIK_SESSION = 'loan/PUT_KONTOMATIK_SESSION';
export const PUT_KONTOMATIK_SESSION_SUCCESS = 'loan/PUT_KONTOMATIK_SESSION_SUCCESS';
export const PUT_KONTOMATIK_SESSION_FAIL = 'loan/PUT_KONTOMATIK_SESSION_FAIL';
export const VERIFICATION_STATE_RESTORE = 'loan/VERIFICATION_STATE_RESTORE';
export const SET_LOAN_FORM_FOOTER_VISIBILITY = 'loan/SET_LOAN_FORM_FOOTER_VISIBILITY';
export const PUT_LOG = 'loan/PUT_LOG';
export const PUT_LOG_SUCCESS = 'loan/PUT_LOG_SUCCESS';
export const PUT_LOG_FAIL = 'loan/PUT_LOG_FAIL';
export const RESET_ADDRESS_SUGGESTIONS = 'loan/RESET_ADDRESS_SUGGESTIONS';
export const RESET_ROBIN_REDIRECT_ID = 'loan/RESET_ROBIN_REDIRECT_ID';
export const PUT_CUSTOMER_PL_AGREEMENTS = 'loan/PUT_CUSTOMER_PL_AGREEMENTS';
export const PUT_CUSTOMER_PL_AGREEMENTS_SUCCESS = 'loan/PUT_CUSTOMER_PL_AGREEMENTS_SUCCESS';
export const PUT_CUSTOMER_PL_AGREEMENTS_FAIL = 'loan/PUT_CUSTOMER_PL_AGREEMENTS_FAIL';
export const PL_INCOME = 'loan/PL_INCOME';
export const SET_INITIAL_LOAN_DATA_EE = 'loan/SET_INITIAL_LOAN_DATA_EE';
export const SET_LOAN_PURPOSE = 'loan/SET_LOAN_PURPOSE';
export const TOGGLE_ADDRESS_DETAILS = 'loan/TOGGLE_ADDRESS_DETAILS';
export const SET_CUSTOMER_EMAIL = 'loan/SET_CUSTOMER_EMAIL';
export const SET_LEGACY_BALANCE = 'loan/SET_LEGACY_BALANCE';
export const SET_BROKER_APP = 'loan/SET_BROKER_APP';
export const INIT_LOAN_STEP = 'loan/INIT_LOAN_STEP';
export const IDENT_DOCUMENTS = 'loan/IDENT_DOCUMENTS';
export const IDENT_DOCUMENTS_SUCCESS = 'loan/IDENT_DOCUMENTS_SUCCESS';
export const IDENT_DOCUMENTS_FAIL = 'loan/IDENT_DOCUMENTS_FAIL';
export const REMOVE_ACTION_ERROR = 'loan/REMOVE_ACTION_ERROR';
export const INCOME_AU = 'loan/INCOME_AU';
export const INCOME_AU_SUCCESS = 'loan/INCOME_AU_SUCCESS';
export const INCOME_AU_FAIL = 'loan/INCOME_AU_FAIL';
export const EXPENSES_AU = 'loan/EXPENSES_AU';
export const EXPENSES_AU_SUCCESS = 'loan/EXPENSES_AU_SUCCESS';
export const EXPENSES_AU_FAIL = 'loan/EXPENSES_AU_FAIL';
export const LOANS_AU = 'loan/LOANS_AU';
export const LOANS_AU_SUCCESS = 'loan/LOANS_AU_SUCCESS';
export const LOANS_AU_FAIL = 'loan/LOANS_AU_FAIL';
export const INIT_APPLICATION_SCORING = 'loan/INIT_APPLICATION_SCORING';
export const INIT_APPLICATION_SCORING_SUCCESS = 'loan/INIT_APPLICATION_SCORING_SUCCESS';
export const INIT_APPLICATION_SCORING_FAIL = 'loan/INIT_APPLICATION_SCORING_FAIL';
export const REPAYMENT_PLAN_AVAILABILITY = 'loan/REPAYMENT_PLAN_AVAILABILITY';
export const REPAYMENT_PLAN_AVAILABILITY_SUCCESS = 'loan/REPAYMENT_PLAN_AVAILABILITY_SUCCESS';
export const REPAYMENT_PLAN_AVAILABILITY_FAIL = 'loan/REPAYMENT_PLAN_AVAILABILITY_FAIL';
export const EXTRA_SERVICE_QUESTIONS = 'loan/EXTRA_SERVICE_QUESTIONS';
export const EXTRA_SERVICE_QUESTIONS_SUCCESS = 'loan/EXTRA_SERVICE_QUESTIONS_SUCCESS';
export const EXTRA_SERVICE_QUESTIONS_FAIL = 'loan/EXTRA_SERVICE_QUESTIONS_FAIL';
export const EXTRA_SERVICES_AVAILABILITY = 'loan/EXTRA_SERVICES_AVAILABILITY';
export const EXTRA_SERVICES_AVAILABILITY_SUCCESS = 'loan/EXTRA_SERVICES_AVAILABILITY_SUCCESS';
export const EXTRA_SERVICES_AVAILABILITY_FAIL = 'loan/EXTRA_SERVICES_AVAILABILITY_FAIL';
export const EXTRA_SERVICES_ADDITONAL_INFO = 'loan/EXTRA_SERVICES_ADDITONAL_INFO';
export const EXTRA_SERVICES_ADDITONAL_INFO_SUCCESS = 'loan/EXTRA_SERVICES_ADDITONAL_INFO_SUCCESS';
export const EXTRA_SERVICES_ADDITONAL_INFO_FAIL = 'loan/EXTRA_SERVICES_ADDITONAL_INFO_FAIL';
export const PUT_MEDICARE = 'loan/PUT_MEDICARE';
export const PUT_MEDICARE_SUCCESS = 'loan/PUT_MEDICARE_SUCCESS';
export const PUT_MEDICARE_FAIL = 'loan/PUT_MEDICARE_FAIL';
export const PUT_BILL_PROTECTOR = 'loan/PUT_BILL_PROTECTOR';
export const PUT_BILL_PROTECTOR_SUCCESS = 'loan/PUT_BILL_PROTECTOR_SUCCESS';
export const PUT_BILL_PROTECTOR_FAIL = 'loan/PUT_BILL_PROTECTOR_FAIL';
export const PUT_REPAYMENT_PLAN = 'loan/PUT_REPAYMENT_PLAN';
export const PUT_REPAYMENT_PLAN_SUCCESS = 'loan/PUT_REPAYMENT_PLAN_SUCCESS';
export const PUT_REPAYMENT_PLAN_FAIL = 'loan/PUT_REPAYMENT_PLAN_FAIL';
export const CALMA_AVAILABILITY = 'loan/CALMA_AVAILABILITY';
export const CALMA_AVAILABILITY_SUCCESS = 'loan/CALMA_AVAILABILITY_SUCCESS';
export const CALMA_AVAILABILITY_FAIL = 'loan/CALMA_AVAILABILITY_FAIL';
export const PUT_CALMA = 'loan/PUT_CALMA';
export const PUT_CALMA_SUCCESS = 'loan/PUT_CALMA_SUCCESS';
export const PUT_CALMA_FAIL = 'loan/PUT_CALMA_FAIL';
export const GET_OFFER_PRODUCTS_AU = 'loan/GET_OFFER_PRODUCTS_AU';
export const GET_OFFER_PRODUCTS_AU_SUCCESS = 'loan/GET_OFFER_PRODUCTS_AU_SUCCESS';
export const GET_OFFER_PRODUCTS_AU_FAIL = 'loan/GET_OFFER_PRODUCTS_AU_FAIL';
export const SCORING_STATUS_AU = 'loan/SCORING_STATUS_AU';
export const SCORING_STATUS_AU_SUCCESS = 'loan/SCORING_STATUS_AU_SUCCESS';
export const SCORING_STATUS_AU_FAIL = 'loan/SCORING_STATUS_AU_FAIL';
export const SCORING_STATUS_ES = 'loan/SCORING_STATUS_ES';
export const SCORING_STATUS_ES_SUCCESS = 'loan/SCORING_STATUS_ES_SUCCESS';
export const SCORING_STATUS_ES_FAIL = 'loan/SCORING_STATUS_ES_FAIL';
export const GET_LEGAL_DOCUMENT = 'loan/GET_LEGAL_DOCUMENT';
export const GET_LEGAL_DOCUMENT_SUCCESS = 'loan/GET_LEGAL_DOCUMENT_SUCCESS';
export const GET_LEGAL_DOCUMENT_FAIL = 'loan/GET_LEGAL_DOCUMENT_FAIL';
export const GET_LOAN_PURPOSES = 'loan/GET_LOAN_PURPOSES';
export const GET_LOAN_PURPOSES_SUCCESS = 'loan/GET_LOAN_PURPOSES_SUCCESS';
export const GET_LOAN_PURPOSES_FAIL = 'loan/GET_LOAN_PURPOSES_FAIL';
export const VERIFY_LOAN_PURPOSES = 'loan/VERIFY_LOAN_PURPOSES';
export const VERIFY_LOAN_PURPOSES_SUCCESS = 'loan/VERIFY_LOAN_PURPOSES_SUCCESS';
export const VERIFY_LOAN_PURPOSES_FAIL = 'loan/VERIFY_LOAN_PURPOSES_FAIL';
export const POST_LOAN_PURPOSES = 'loan/POST_LOAN_PURPOSES';
export const POST_LOAN_PURPOSES_SUCCESS = 'loan/POST_LOAN_PURPOSES_SUCCESS';
export const POST_LOAN_PURPOSES_FAIL = 'loan/POST_LOAN_PURPOSES_FAIL';
export const PUT_UPDATE_LIVING_ADDRESS = 'loan/PUT_UPDATE_LIVING_ADDRESS';
export const PUT_UPDATE_LIVING_ADDRESS_SUCCESS = 'loan/PUT_UPDATE_LIVING_ADDRESS_SUCCESS';
export const PUT_UPDATE_LIVING_ADDRESS_FAIL = 'loan/PUT_UPDATE_LIVING_ADDRESS_FAIL';
export const LOAN_TYPE_LT = 'loan/LOAN_TYPE_LT';
export const LOAN_TYPE_LT_SUCCESS = 'loan/LOAN_TYPE_LT_SUCCESS';
export const LOAN_TYPE_LT_FAIL = 'loan/LOAN_TYPE_LT_FAIL';
export const INCOME_LT = 'loan/INCOME_LT';
export const INCOME_LT_SUCCESS = 'loan/INCOME_LT_SUCCESS';
export const INCOME_LT_FAIL = 'loan/INCOME_LT_FAIL';
export const LIABILITIES_LT = 'loan/LIABILITIES_LT';
export const LIABILITIES_LT_SUCCESS = 'loan/LIABILITIES_LT_SUCCESS';
export const LIABILITIES_LT_FAIL = 'loan/LIABILITIES_LT_FAIL';
export const CLEAR_LOAN_VALIDATION_ERROR = 'loan/CLEAR_LOAN_VALIDATION_ERROR';
export const POST_CUSTOMER_PL_NOTIFICATION = 'loan/POST_CUSTOMER_PL_NOTIFICATION';
export const POST_CUSTOMER_PL_NOTIFICATION_SUCCESS = 'loan/POST_CUSTOMER_PL_NOTIFICATION_SUCCESS';
export const POST_CUSTOMER_PL_NOTIFICATION_FAIL = 'loan/POST_CUSTOMER_PL_NOTIFICATION_FAIL';
export const VAS_CONFIRM = 'loan/VAS_CONFIRM';
export const VAS_CONFIRM_SUCCESS = 'loan/VAS_CONFIRM_SUCCESS';
export const VAS_CONFIRM_FAIL = 'loan/VAS_CONFIRM_FAIL';
export const VAS_TOGGLE = 'loan/VAS_TOGGLE';
export const FETCH_EXTERNAL_REGISTRIES = 'loan/FETCH_EXTERNAL_REGISTRIES';
export const FETCH_EXTERNAL_REGISTRIES_SUCCESS = 'loan/FETCH_EXTERNAL_REGISTRIES_SUCCESS';
export const FETCH_EXTERNAL_REGISTRIES_FAIL = 'loan/FETCH_EXTERNAL_REGISTRIES_FAIL';
export const GET_SALARY_DATA = 'loan/GET_SALARY_DATA';
export const GET_SALARY_DATA_SUCCESS = 'loan/GET_SALARY_DATA_SUCCESS';
export const GET_SALARY_DATA_FAIL = 'loan/GET_SALARY_DATA_FAIL';
export const GET_DOCUMENT_TYPE = 'loan/GET_DOCUMENT_TYPE';
export const GET_DOCUMENT_TYPE_SUCCESS = 'loan/GET_DOCUMENT_TYPE_SUCCESS';
export const GET_DOCUMENT_TYPE_FAIL = 'loan/GET_DOCUMENT_TYPE_FAIL';
export const CHECK_EXTERNAL_POLICIES = 'loan/CHECK_EXTERNAL_POLICIES';
export const CHECK_EXTERNAL_POLICIES_SUCCESS = 'loan/CHECK_EXTERNAL_POLICIES_SUCCESS';
export const CHECK_EXTERNAL_POLICIES_FAIL = 'loan/CHECK_EXTERNAL_POLICIES_FAIL';
export const GET_CITIZENSHIPS = 'loan/GET_CITIZENSHIPS';
export const GET_CITIZENSHIPS_SUCCESS = 'loan/GET_CITIZENSHIPS_SUCCESS';
export const GET_CITIZENSHIPS_FAIL = 'loan/GET_CITIZENSHIPS_FAIL';
export const GO_TO_BANK_STATEMENT = 'loan/GO_TO_BANK_STATEMENT';
export const POST_BANK_STATEMENTS = 'loan/POST_BANK_STATEMENTS';
export const POST_BANK_STATEMENTS_SUCCESS = 'loan/POST_BANK_STATEMENTS_SUCCESS';
export const POST_BANK_STATEMENTS_FAIL = 'loan/POST_BANK_STATEMENTS_FAIL';
export const POST_IDENTITY_DOCUMENTS = 'loan/POST_IDENTITY_DOCUMENTS';
export const POST_IDENTITY_DOCUMENTS_SUCCESS = 'loan/POST_IDENTITY_DOCUMENTS_SUCCESS';
export const POST_IDENTITY_DOCUMENTS_FAIL = 'loan/POST_IDENTITY_DOCUMENTS_FAIL';
export const SKIP_BANK_STATEMENTS = 'loan/SKIP_BANK_STATEMENTS';
export const POST_BANK_STATEMENTS_UPLOAD_DONE = 'loan/POST_BANK_STATEMENTS_UPLOAD_DONE';
export const POST_BANK_STATEMENTS_UPLOAD_DONE_SUCCESS = 'loan/POST_BANK_STATEMENTS_UPLOAD_DONE_SUCCESS';
export const POST_BANK_STATEMENTS_UPLOAD_DONE_FAIL = 'loan/POST_BANK_STATEMENTS_UPLOAD_DONE_FAIL';
export const POST_LIBERTO_TOKEN = 'loan/POST_LIBERTO_TOKEN';
export const POST_LIBERTO_TOKEN_SUCCESS = 'loan/POST_LIBERTO_TOKEN_SUCCESS';
export const POST_LIBERTO_TOKEN_FAIL = 'loan/POST_LIBERTO_TOKEN_FAIL';
export const SAVE_LIBERTO_SUCCESS = 'loan/SAVE_LIBERTO_SUCCESS';
export const SKIP_LIBERTO = 'loan/SKIP_LIBERTO';
export const SKIP_CALMA = 'loan/SKIP_CALMA';
export const SET_CZ_INCOME_VERIFICATION_WAY = 'loan/SET_CZ_INCOME_VERIFICATION_WAY';
export const SET_CZ_IDENTITY_VERIFICATION_WAY = 'loan/SET_CZ_IDENTITY_VERIFICATION_WAY';
export const SKIP_CZ_INCOME_VERIFICATION = 'loan/SKIP_CZ_INCOME_VERIFICATION';
export const SKIP_CZ_IDENTITY_VERIFICATION = 'loan/SKIP_CZ_IDENTITY_VERIFICATION_WAY';
export const GET_MX_BANKS = 'loan/GET_MX_BANKS';
export const GET_MX_BANKS_SUCCESS = 'loan/GET_MX_BANKS_SUCCESS';
export const GET_MX_BANKS_FAIL = 'loan/GET_MX_BANKS_FAIL';
export const SHOW_OTP_SECTION = 'loan/SHOW_OTP_SECTION';
export const HIDE_OTP_SECTION = 'loan/HIDE_OTP_SECTION';
export const INIT_OTP = 'loan/INIT_OTP';
export const INIT_OTP_SUCCESS = 'loan/INIT_OTP_SUCCESS';
export const INIT_OTP_FAIL = 'loan/INIT_OTP_FAIL';
export const VALIDATE_OTP = 'loan/VALIDATE_OTP';
export const VALIDATE_OTP_SUCCESS = 'loan/VALIDATE_OTP_SUCCESS';
export const VALIDATE_OTP_FAIL = 'loan/VALIDATE_OTP_FAIL';
export const GET_CHANNEL_LIST = 'loan/GET_CHANNEL_LIST';
export const GET_CHANNEL_LIST_SUCCESS = 'loan/GET_CHANNEL_LIST_SUCCESS';
export const GET_CHANNEL_LIST_FAIL = 'loan/GET_CHANNEL_LIST_FAIL';
export const GET_BANK_ACCOUNT = 'loan/GET_BANK_ACCOUNT';
export const GET_BANK_ACCOUNT_SUCCESS = 'loan/GET_BANK_ACCOUNT_SUCCESS';
export const GET_BANK_ACCOUNT_FAIL = 'loan/GET_BANK_ACCOUNT_FAIL';
export const GET_FINPASS_BANKS = 'loan/GET_FINPASS_BANKS';
export const GET_FINPASS_BANKS_SUCCESS = 'loan/GET_FINPASS_BANKS_SUCCESS';
export const GET_FINPASS_BANKS_FAIL = 'loan/GET_FINPASS_BANKS_FAIL';
export const GET_FINPASS_REDIRECT_URL = 'loan/GET_FINPASS_REDIRECT_URL';
export const GET_FINPASS_REDIRECT_URL_SUCCESS = 'loan/GET_FINPASS_REDIRECT_URL_SUCCESS';
export const GET_FINPASS_REDIRECT_URL_FAIL = 'loan/GET_FINPASS_REDIRECT_URL_FAIL';
export const START_FINPASS = 'loan/START_FINPASS';
export const START_FINPASS_SUCCESS = 'loan/START_FINPASS_SUCCESS';
export const START_FINPASS_FAIL = 'loan/START_FINPASS_FAIL';
export const FINISH_FINPASS = 'loan/FINISH_FINPASS';
export const GET_PROVISO_IFRAME_URL = 'loan/GET_PROVISO_IFRAME_URL';
export const GET_PROVISO_IFRAME_URL_SUCCESS = 'loan/GET_PROVISO_IFRAME_URL_SUCCESS';
export const GET_PROVISO_IFRAME_URL_FAIL = 'loan/GET_PROVISO_IFRAME_URL_FAIL';
export const RESET_BANK_SCRAPING_RESULT = 'loan/RESET_BANK_SCRAPING_RESULT';
export const PUT_REFERER = 'loan/PUT_REFERER';
export const PUT_REFERER_SUCCESS = 'loan/PUT_REFERER_SUCCESS';
export const PUT_REFERER_FAIL = 'loan/PUT_REFERR_FAIL';
export const GET_AUTO_APPROVAL_STATUS = 'loan/GET_AUTO_APPROVAL_STATUS';
export const GET_AUTO_APPROVAL_STATUS_SUCCESS = 'loan/GET_AUTO_APPROVAL_STATUS_SUCCESS';
export const GET_AUTO_APPROVAL_STATUS_FAIL = 'loan/GET_AUTO_APPROVAL_STATUS_FAIL';
export const PUT_CONTRACT_DETAILS = 'loan/PUT_CONTRACT_DETAILS';
export const PUT_CONTRACT_DETAILS_SUCCESS = 'loan/PUT_CONTRACT_DETAILS_SUCCESS';
export const PUT_CONTRACT_DETAILS_FAIL = 'loan/PUT_CONTRACT_DETAILS_FAIL';
export const PUT_NORDIGEN_CONSENT = 'loan/PUT_NORDIGEN_CONSENT';
export const PUT_NORDIGEN_CONSENT_SUCCESS = 'loan/PUT_NORDIGEN_CONSENT_SUCCESS';
export const PUT_NORDIGEN_CONSENT_FAIL = 'loan/PUT_NORDIGEN_CONSENT_FAIL';
export const PUT_NORDIGEN_REQUEST_ID = 'loan/PUT_NORDIGEN_REQUEST_ID';
export const PUT_NORDIGEN_REQUEST_ID_SUCCESS = 'loan/PUT_NORDIGEN_REQUEST_ID_SUCCESS';
export const PUT_NORDIGEN_REQUEST_ID_FAIL = 'loan/PUT_NORDIGEN_REQUEST_ID_FAIL';
export const CLOSE_POPUP = 'loan/CLOSE_POPUP';
export const EID_SHOW_POPUP = 'loan/EID_SHOW_POPUP';
export const LIBERTO_FAIL = 'loan/LIBERTO_FAIL';
export const PUT_REJECT_LOAN = 'loan/PUT_REJECT_LOAN';
export const PUT_REJECT_LOAN_SUCCESS = 'loan/PUT_REJECT_LOAN_SUCCESS';
export const PUT_REJECT_LOAN_FAIL = 'loan/PUT_REJECT_LOAN_FAIL';
export const LEGAL = 'loan/LEGAL';
export const SET_CREDIT_APPLICATION_ID = 'loan/SET_CREDIT_APPLICATION_ID';
export const CLOSE_GUARANTOR_APPLICATION = 'loan/CLOSE_GUARANTOR_APPLICATION';
export const CLOSE_GUARANTOR_APPLICATION_SUCCESS = 'loan/CLOSE_GUARANTOR_APPLICATION_SUCCESS';
export const CLOSE_GUARANTOR_APPLICATION_FAIL = 'loan/CLOSE_GUARANTOR_APPLICATION_FAIL';
export const GET_FEES = 'loan/GET_FEES';
export const GET_FEES_SUCCESS = 'loan/GET_FEES_SUCCESS';
export const GET_FEES_FAIL = 'loan/GET_FEES_FAIL';
export const SET_GUARANTOR_TYPE = 'loan/SET_GUARANTOR_TYPE';
export const SKIP_EID = 'loan/SKIP_EID';
export const SKIP_KONTOMATIK = 'loan/SKIP_KONTOMATIK';
export const SET_RESCORING_TO_DO_FOR_OPEN_CREDIT_APPLICATION = 'loan/SET_RESCORING_TO_DO_FOR_OPEN_CREDIT_APPLICATION';
export const SET_STEPS = 'loan/SET_STEPS';
export const SET_LAST_STATUS_PAGE = 'loan/SET_LAST_STATUS_PAGE';
export const SET_REJECTION = 'loan/SET_REJECTION';
export const TOGGLE_CONFIRMATION_BUTTON_VISIBILITY = 'loan/TOGGLE_CONFIRMATION_BUTTON_VISIBILITY';
export const GET_MIGRATION_PRODUCTS = 'loan/GET_MIGRATION_PRODUCTS';
export const GET_MIGRATION_PRODUCTS_SUCCESS = 'loan/GET_MIGRATION_PRODUCTS_SUCCESS';
export const GET_MIGRATION_PRODUCTS_FAIL = 'loan/GET_MIGRATION_PRODUCTS_FAIL';
export const PATCH_GUARANTOR_ES = 'loan/PATCH_GUARANTOR_ES';
export const PATCH_GUARANTOR_ES_FAIL = 'loan/PATCH_GUARANTOR_ES_FAIL';
export const PATCH_GUARANTOR_ES_SUCCESS = 'loan/PATCH_GUARANTOR_ES_SUCCESS';
export const POST_MIGRATION_SCORING_ES = 'loan/POST_MIGRATION_SCORING_ES';
export const POST_MIGRATION_SCORING_ES_SUCCESS = 'loan/POST_MIGRATION_SCORING_ES_SUCCESS';
export const POST_MIGRATION_SCORING_ES_FAIL = 'loan/POST_MIGRATION_SCORING_ES_FAIL';
export const GET_MIGRATION_SCORING_ES = 'loan/GET_MIGRATION_SCORING_ES';
export const GET_MIGRATION_SCORING_ES_SUCCESS = 'loan/GET_MIGRATION_SCORING_ES_SUCCESS';
export const GET_MIGRATION_SCORING_ES_FAIL = 'loan/GET_MIGRATION_SCORING_ES_FAIL';
export const GET_CONTRACT = 'loan/GET_CONTRACT';
export const GET_CONTRACT_SUCCESS = 'loan/GET_CONTRACT_SUCCESS';
export const GET_CONTRACT_FAIL = 'loan/GET_CONTRACT_FAIL';
export const PUT_MIGRATION_PRODUCT = 'loan/PUT_MIGRATION_PRODUCT';
export const PUT_MIGRATION_PRODUCT_SUCCESS = 'loan/PUT_MIGRATION_PRODUCT_SUCCESS';
export const PUT_MIGRATION_PRODUCT_FAIL = 'loan/PUT_MIGRATION_PRODUCT_FAIL';
export const GET_MIGRATION_MMPS = 'loan/GET_MIGRATION_MMPS';
export const GET_MIGRATION_MMPS_SUCCESS = 'loan/GET_MIGRATION_MMPS_SUCCESS';
export const GET_MIGRATION_MMPS_FAIL = 'loan/GET_MIGRATION_MMPS_FAIL';
export const SET_LOAN_SUBMITTING = 'loan/SET_LOAN_SUBMITTING';
export const UNSET_LOAN_SUBMITTING = 'loan/UNSET_LOAN_SUBMITTING';
export const GET_NORDIGEN_BANKS = 'loan/GET_NORDIGEN_BANKS';
export const GET_NORDIGEN_BANKS_SUCCESS = 'loan/GET_NORDIGEN_BANKS_SUCCESS';
export const GET_NORDIGEN_BANKS_FAIL = 'loan/GET_NORDIGEN_BANKS_FAIL';
export const SET_NORDIGEN_BANK = 'loan/SET_NORDIGEN_BANK';
export const POST_NORDIGEN_BANK = 'loan/POST_NORDIGEN_BANK';
export const POST_NORDIGEN_BANK_SUCCESS = 'loan/POST_NORDIGEN_BANK_SUCCESS';
export const POST_NORDIGEN_BANK_FAIL = 'loan/POST_NORDIGEN_BANK_FAIL';
export const SKIP_NORDIGEN_STEP = 'loan/SKIP_NORDIGEN_STEP';
export const SET_NORDIGEN_ERROR = 'loan/SET_NORDIGEN_ERROR';
export const GET_NORDIGEN_ACCOUNT = 'loan/GET_NORDIGEN_ACCOUNT';
export const GET_NORDIGEN_ACCOUNT_SUCCESS = 'loan/GET_NORDIGEN_ACCOUNT_SUCCESS';
export const GET_NORDIGEN_ACCOUNT_FAIL = 'loan/GET_NORDIGEN_ACCOUNT_FAIL';
export const GO_TO_CREDIT_LIMIT = 'loan/GO_TO_CREDIT_LIMIT';
export const SEND_CONFIRMATION_KEY = 'loan/SEND_CONFIRMATION_KEY';
export const REDIRECT_LOGIN = 'loan/REDIRECT_LOGIN';
export const SET_REQUESTED_FINANCIAL_DATA = 'loan/SET_REQUESTED_FINANCIAL_DATA';
export const SET_PROVISO_SKIP_AU = 'loan/SET_PROVISO_SKIP_AU';
export const INIT_CREDIT_APPLICATION = 'loan/INIT_CREDIT_APPLICATION';
export const INIT_CREDIT_APPLICATION_SUCCESS = 'loan/INIT_CREDIT_APPLICATION_SUCCESS';
export const INIT_CREDIT_APPLICATION_FAIL = 'loan/INIT_CREDIT_APPLICATION_FAIL';
export const GET_CREDIT_APPLICATION_LOAN = 'loan/GET_CREDIT_APPLICATION_LOAN';
export const GET_CREDIT_APPLICATION_LOAN_SUCCESS = 'loan/GET_CREDIT_APPLICATION_LOAN_SUCCESS';
export const GET_CREDIT_APPLICATION_LOAN_FAIL = 'loan/GET_CREDIT_APPLICATION_LOAN_FAIL';
export const START_REIDENTIFY_CUSTOMER = 'loan/START_REIDENTIFY_CUSTOMER';
export const START_REIDENTIFY_CUSTOMER_SUCCESS = 'loan/START_REIDENTIFY_CUSTOMER_SUCCESS';
export const START_REIDENTIFY_CUSTOMER_FAIL = 'loan/START_REIDENTIFY_CUSTOMER_FAIL';
export const REIDENTIFY_CUSTOMER = 'loan/REIDENTIFY_CUSTOMER';
export const REIDENTIFY_CUSTOMER_SUCCESS = 'loan/REIDENTIFY_CUSTOMER_SUCCESS';
export const REIDENTIFY_CUSTOMER_FAIL = 'loan/REIDENTIFY_CUSTOMER_FAIL';
export const FINISH_REIDENTIFY_CUSTOMER = 'loan/FINISH_REIDENTIFY_CUSTOMER';
export const FINISH_REIDENTIFY_CUSTOMER_SUCCESS = 'loan/FINISH_REIDENTIFY_CUSTOMER_SUCCESS';
export const FINISH_REIDENTIFY_CUSTOMER_FAIL = 'loan/FINISH_REIDENTIFY_CUSTOMER_FAIL';
export const CREATE_CREDIT_APPLICATION_AFTER_REIDENTIFY = 'loan/CREATE_CREDIT_APPLICATION_AFTER_REIDENTIFY';
export const CREATE_CREDIT_APPLICATION_AFTER_REIDENTIFY_SUCCESS = 'loan/CREATE_CREDIT_APPLICATION_AFTER_REIDENTIFY_SUCCESS';
export const CREATE_CREDIT_APPLICATION_AFTER_REIDENTIFY_FAIL = 'loan/CREATE_CREDIT_APPLICATION_AFTER_REIDENTIFY_FAIL';
export const CHECK_IF_USER_NEED_REIDENTIFY = 'loan/CHECK_IF_USER_NEED_REIDENTIFY';
export const CHECK_IF_USER_NEED_REIDENTIFY_SUCCESS = 'loan/CHECK_IF_USER_NEED_REIDENTIFY_SUCCESS';
export const CHECK_IF_USER_NEED_REIDENTIFY_FAIL = 'loan/CHECK_IF_USER_NEED_REIDENTIFY_FAIL';
export const GO_TO_NEXT_STEP = 'loan/GO_TO_NEXT_STEP';
export const CHECK_FOR_TAX_AUTHORITY_DATA = 'loan/CHECK_FOR_TAX_AUTHORITY_DATA';
export const CHECK_FOR_TAX_AUTHORITY_DATA_SUCCESS = 'loan/CHECK_FOR_TAX_AUTHORITY_DATA_SUCCESS';
export const CHECK_FOR_TAX_AUTHORITY_DATA_FAIL = 'loan/CHECK_FOR_TAX_AUTHORITY_DATA_FAIL';
export const REMOVE_IDENTIFY_VERIFICATION_WAY = 'loan/REMOVE_IDENTIFY_VERIFICATION_WAY';
export const GET_REJECTED_APPLICATION_TOKEN = 'loan/GET_REJECTED_APPLICATION_TOKEN';
export const GET_REJECTED_APPLICATION_TOKEN_SUCCESS = 'loan/GET_REJECTED_APPLICATION_TOKEN_SUCCESS';
export const GET_REJECTED_APPLICATION_TOKEN_FAIL = 'loan/GET_REJECTED_APPLICATION_TOKEN_FAIL';
export const GET_CREDIT_APPLICATION_AU = 'loan/GET_CREDIT_APPLICATION_AU';
export const GET_CREDIT_APPLICATION_AU_SUCCESS = 'loan/GET_CREDIT_APPLICATION_AU_SUCCESS';
export const GET_CREDIT_APPLICATION_AU_FAIL = 'loan/GET_CREDIT_APPLICATION_AU_FAIL';

export const GET_PRODUCT_NAME = 'loan/GET_PRODUCT_NAME';
export const GET_PRODUCT_NAME_SUCCESS = 'loan/GET_PRODUCT_NAME_SUCCESS';
export const GET_PRODUCT_NAME_FAIL = 'loan/GET_PRODUCT_NAME_FAIL';

export const GET_GOV_BENEFITS_VALUE = 'loan/GET_GOV_BENEFITS_VALUE';
export const GET_GOV_BENEFITS_VALUE_SUCCESS = 'loan/GET_GOV_BENEFITS_VALUE_SUCCESS';
export const GET_GOV_BENEFITS_VALUE_FAIL = 'loan/GET_GOV_BENEFITS_VALUE_FAIL';

export const SHOULD_SHOW_SACC_PAGE = 'loan/SHOULD_SHOW_SACC_PAGE';
export const GO_TO_SPECIFIC_STEP = 'loan/GO_TO_SPECIFIC_STEP';
export const CHANGE_LOAN_SUBMITTING_STATE = 'loan/CHANGE_LOAN_SUBMITTING_STATE';

// self-service
export const GET_CONTRACT_DATA = 'selfservice/GET_CONTRACT_DATA';
export const GET_CONTRACT_DATA_SUCCESS = 'selfservice/GET_CONTRACT_DATA_SUCCESS';
export const GET_CONTRACT_DATA_FAIL = 'selfservice/GET_CONTRACT_DATA_FAIL';
export const GET_ACCOUNT_STATEMENT = 'selfservice/GET_ACCOUNT_STATEMENT';
export const GET_ACCOUNT_STATEMENT_SUCCESS = 'selfservice/GET_ACCOUNT_STATEMENT_SUCCESS';
export const GET_ACCOUNT_STATEMENT_FAIL = 'selfservice/GET_ACCOUNT_STATEMENT_FAIL';
export const GET_ACCOUNT_STATEMENT_DETAILED = 'selfservice/GET_ACCOUNT_STATEMENT_DETAILED';
export const GET_ACCOUNT_STATEMENT_DETAILED_SUCCESS = 'selfservice/GET_ACCOUNT_STATEMENT_DETAILED_SUCCESS';
export const GET_ACCOUNT_STATEMENT_DETAILED_FAIL = 'selfservice/GET_ACCOUNT_STATEMENT_DETAILED_FAIL';
export const GET_OPEN_INVOICE = 'selfservice/GET_OPEN_INVOICE';
export const GET_OPEN_INVOICE_SUCCESS = 'selfservice/GET_OPEN_INVOICE_SUCCESS';
export const GET_OPEN_INVOICE_FAIL = 'selfservice/GET_OPEN_INVOICE_FAIL';
export const GET_INVOICES = 'selfservice/GET_INVOICES';
export const GET_INVOICES_SUCCESS = 'selfservice/GET_INVOICES_SUCCESS';
export const GET_INVOICES_FAIL = 'selfservice/GET_INVOICES_FAIL';
export const GET_LAST_INVOICE = 'selfservice/GET_LAST_INVOICE';
export const GET_LAST_INVOICE_SUCCESS = 'selfservice/GET_LAST_INVOICE_SUCCESS';
export const GET_LAST_INVOICE_FAIL = 'selfservice/GET_LAST_INVOICE_FAIL';
export const GET_MMPS = 'selfservice/GET_MMPS';
export const GET_MMPS_SUCCESS = 'selfservice/GET_MMPS_SUCCESS';
export const GET_MMPS_FAIL = 'selfservice/GET_MMPS_FAIL';
export const PUT_WITHDRAWAL = 'selfservice/PUT_WITHDRAWAL';
export const PUT_WITHDRAWAL_SUCCESS = 'selfservice/PUT_WITHDRAWAL_SUCCESS';
export const PUT_WITHDRAWAL_FAIL = 'selfservice/PUT_WITHDRAWAL_FAIL';
export const PUT_NEW_CREDIT_LINE = 'selfservice/PUT_NEW_CREDIT_LINE';
export const PUT_NEW_CREDIT_LINE_SUCCESS = 'selfservice/PUT_NEW_CREDIT_LINE_SUCCESS';
export const PUT_NEW_CREDIT_LINE_FAIL = 'selfservice/PUT_NEW_CREDIT_LINE_FAIL';
export const GET_BANK_NAME = 'selfservice/GET_BANK_NAME';
export const GET_BANK_NAME_SUCCESS = 'selfservice/GET_BANK_NAME_SUCCESS';
export const GET_BANK_NAME_FAIL = 'selfservice/GET_BANK_NAME_FAIL';
export const SAVE_PHONE_NUMBER = 'selfservice/SAVE_PHONE_NUMBER';
export const SAVE_PHONE_NUMBER_SUCCESS = 'selfservice/SAVE_PHONE_NUMBER_SUCCESS';
export const SAVE_PHONE_NUMBER_FAIL = 'selfservice/SAVE_PHONE_NUMBER_FAIL';
export const SAVE_BANK_ACCOUNT = 'selfservice/SAVE_BANK_ACCOUNT';
export const SAVE_BANK_ACCOUNT_SUCCESS = 'selfservice/SAVE_BANK_ACCOUNT_SUCCESS';
export const SAVE_BANK_ACCOUNT_FAIL = 'selfservice/SAVE_BANK_ACCOUNT_FAIL';
export const SAVE_PASSWORD = 'selfservice/SAVE_PASSWORD';
export const SAVE_PASSWORD_SUCCESS = 'selfservice/SAVE_PASSWORD_SUCCESS';
export const SAVE_PASSWORD_FAIL = 'selfservice/SAVE_PASSWORD_FAIL';
export const SAVE_MARKETING_CONSENTS = 'selfservice/SAVE_MARKETING_CONSENTS';
export const SAVE_MARKETING_CONSENTS_SUCCESS = 'selfservice/SAVE_MARKETING_CONSENTS_SUCCESS';
export const SAVE_MARKETING_CONSENTS_FAIL = 'selfservice/SAVE_MARKETING_CONSENTS_FAIL';
export const RESEND_CONFIRMATION_EMAIL = 'selfservice/RESEND_CONFIRMATION_EMAIL';
export const RESEND_CONFIRMATION_EMAIL_SUCCESS = 'selfservice/RESEND_CONFIRMATION_EMAIL_SUCCESS';
export const RESEND_CONFIRMATION_EMAIL_FAIL = 'selfservice/RESEND_CONFIRMATION_EMAIL_FAIL';
export const SAVE_CONTACT_INFO = 'selfservice/SAVE_CONTACT_INFO';
export const SAVE_CONTACT_INFO_SUCCESS = 'selfservice/SAVE_CONTACT_INFO_SUCCESS';
export const SAVE_CONTACT_INFO_FAIL = 'selfservice/SAVE_CONTACT_INFO_FAIL';
export const UPDATE_CONTACT_INFO = 'selfservice/UPDATE_CONTACT_INFO';
export const UPDATE_CONTACT_INFO_SUCCESS = 'selfservice/UPDATE_CONTACT_INFO_SUCCESS';
export const UPDATE_CONTACT_INFO_FAIL = 'selfservice/UPDATE_CONTACT_INFO_FAIL';
export const VERIFY_MSISDN = 'selfservice/VERIFY_MSISDN';
export const VERIFY_MSISDN_SUCCESS = 'selfservice/VERIFY_MSISDN_SUCCESS';
export const VERIFY_MSISDN_FAIL = 'selfservice/VERIFY_MSISDN_FAIL';
export const CANCEL_UPDATE_DATA = 'selfservice/CANCEL_UPDATE_DATA';
export const GET_CONTRACT_FREEZE = 'selfservice/GET_CONTRACT_FREEZE';
export const GET_CONTRACT_FREEZE_SUCCESS = 'selfservice/GET_CONTRACT_FREEZE_SUCCESS';
export const GET_CONTRACT_FREEZE_FAIL = 'selfservice/GET_CONTRACT_FREEZE_FAIL';
export const GET_DUE_DATE_RANGE = 'selfservice/GET_DUE_DATE_RANGE';
export const GET_DUE_DATE_RANGE_SUCCESS = 'selfservice/GET_DUE_DATE_RANGE_SUCCESS';
export const GET_DUE_DATE_RANGE_FAIL = 'selfservice/GET_DUE_DATE_RANGE_FAIL';
export const GET_PAYMENT_HOLIDAY = 'selfservice/GET_PAYMENT_HOLIDAY';
export const GET_PAYMENT_HOLIDAY_SUCCESS = 'selfservice/GET_PAYMENT_HOLIDAY_SUCCESS';
export const GET_PAYMENT_HOLIDAY_FAIL = 'selfservice/GET_PAYMENT_HOLIDAY_FAIL';
export const TAKE_PAYMENT_HOLIDAY = 'selfservice/TAKE_PAYMENT_HOLIDAY';
export const TAKE_PAYMENT_HOLIDAY_SUCCESS = 'selfservice/TAKE_PAYMENT_HOLIDAY_SUCCESS';
export const TAKE_PAYMENT_HOLIDAY_FAIL = 'selfservice/TAKE_PAYMENT_HOLIDAY_FAIL';
export const CHANGE_DUE_DATE = 'selfservice/CHANGE_DUE_DATE';
export const CHANGE_DUE_DATE_SUCCESS = 'selfservice/CHANGE_DUE_DATE_SUCCESS';
export const CHANGE_DUE_DATE_FAIL = 'selfservice/CHANGE_DUE_DATE_FAIL';
export const TOGGLE_DUE_DATE_REMINDER = 'selfservice/TOGGLE_DUE_DATE_REMINDER';
export const TOGGLE_DUE_DATE_REMINDER_SUCCESS = 'selfservice/TOGGLE_DUE_DATE_REMINDER_SUCCESS';
export const TOGGLE_DUE_DATE_REMINDER_FAIL = 'selfservice/TOGGLE_DUE_DATE_REMINDER_FAIL';
export const SET_UPGRADE_HIGHLIGHT_OFF = 'selfservice/SET_UPGRADE_HIGHLIGHT_OFF';
export const START_PROFILE_EDITING = 'selfservice/START_PROFILE_EDITING';
export const CANCEL_PROFILE_EDITING = 'selfservice/CANCEL_PROFILE_EDITING';
export const SET_UPGRADE_SUCCESS_OFF = 'selfservice/SET_UPGRADE_SUCCESS_OFF';
export const GET_MMP_BY_NEW_DUE_DATE = 'selfservice/GET_MMP_BY_NEW_DUE_DATE';
export const GET_MMP_BY_NEW_DUE_DATE_SUCCESS = 'selfservice/GET_MMP_BY_NEW_DUE_DATE_SUCCESS';
export const GET_MMP_BY_NEW_DUE_DATE_FAIL = 'selfservice/GET_MMP_BY_DUE_DATE_FAIL';
export const GET_CREDIT_APPLICATION = 'selfservice/GET_CREDIT_APPLICATION';
export const GET_CREDIT_APPLICATION_SUCCESS = 'selfservice/GET_CREDIT_APPLICATION_SUCCESS';
export const GET_CREDIT_APPLICATION_FAILURE = 'selfservice/GET_CREDIT_APPLICATION_FAILURE';
export const GET_CREDIT_APPLICATION_STATUS = 'selfservice/GET_CREDIT_APPLICATION_STATUS';
export const GET_CREDIT_APPLICATION_STATUS_SUCCESS = 'selfservice/GET_CREDIT_APPLICATION_STATUS_SUCCESS';
export const GET_CREDIT_APPLICATION_STATUS_FAILURE = 'selfservice/GET_CREDIT_APPLICATION_STATUS_FAILURE';
export const GET_STATEMENT_OF_ACCOUNT = 'selfservice/GET_STATEMENT_OF_ACCOUNT';
export const GET_STATEMENT_OF_ACCOUNT_SUCCESS = 'selfservice/GET_STATEMENT_OF_ACCOUNT_SUCCESS';
export const GET_STATEMENT_OF_ACCOUNT_FAIL = 'selfservice/GET_STATEMENT_OF_ACCOUNT_FAIL';
export const GET_STATEMENT_OF_ACCOUNT_PDF = 'selfservice/GET_STATEMENT_OF_ACCOUNT_PDF';
export const GET_STATEMENT_OF_ACCOUNT_PDF_SUCCESS = 'selfservice/GET_STATEMENT_OF_ACCOUNT_PDF_SUCCESS';
export const GET_STATEMENT_OF_ACCOUNT_PDF_FAIL = 'selfservice/GET_STATEMENT_OF_ACCOUNT_PDF_FAIL';
export const GET_PRODUCT_PRINCIPAL = 'selfservice/GET_PRODUCT_PRINCIPAL';
export const GET_PRODUCT_PRINCIPAL_SUCCESS = 'selfservice/GET_PRODUCT_PRINCIPAL_SUCCESS';
export const GET_PRODUCT_PRINCIPAL_FAIL = 'selfservice/GET_PRODUCT_PRINCIPAL_FAIL';
export const GET_PRINCIPAL_BALANCE = 'selfservice/GET_PRINCIPAL_BALANCE';
export const GET_PRINCIPAL_BALANCE_SUCCESS = 'selfservice/GET_PRINCIPAL_BALANCE_SUCCESS';
export const GET_PRINCIPAL_BALANCE_FAIL = 'selfservice/GET_PRINCIPAL_BALANCE_FAIL';
export const GET_UPGRADE_ELIGIBILITY = 'selfservice/GET_UPGRADE_ELIGIBILITY';
export const GET_UPGRADE_ELIGIBILITY_SUCCESS = 'selfservice/GET_UPGRADE_ELIGIBILITY_SUCCESS';
export const GET_UPGRADE_ELIGIBILITY_FAIL = 'selfservice/GET_UPGRADE_ELIGIBILITY_FAIL';
export const GET_UPSELL_ELIGIBILITY = 'selfservice/GET_UPSELL_ELIGIBILITY';
export const GET_UPSELL_ELIGIBILITY_SUCCESS = 'selfservice/GET_UPSELL_ELIGIBILITY_SUCCESS';
export const GET_UPSELL_ELIGIBILITY_FAIL = 'selfservice/GET_UPSELL_ELIGIBILITY_FAIL';
export const APPLY_INCREASE = 'selfservice/APPLY_INCREASE';
export const APPLY_INCREASE_SUCCESS = 'selfservice/APPLY_INCREASE_SUCCESS';
export const APPLY_INCREASE_FAIL = 'selfservice/APPLY_INCREASE_FAIL';
export const GET_UPGRADE_APPLICATION = 'selfservice/GET_UPGRADE_APPLICATION';
export const GET_UPGRADE_APPLICATION_SUCCESS = 'selfservice/GET_UPGRADE_APPLICATION_SUCCESS';
export const GET_UPGRADE_APPLICATION_FAIL = 'selfservice/GET_UPGRADE_APPLICATION_FAIL';
export const POST_UPGRADE_APPLICATION = 'selfservice/POST_UPGRADE_APPLICATION';
export const POST_UPGRADE_APPLICATION_SUCCESS = 'selfservice/POST_UPGRADE_APPLICATION_SUCCESS';
export const POST_UPGRADE_APPLICATION_FAIL = 'selfservice/POST_UPGRADE_APPLICATION_FAIL';
export const CONFIRM_UPGRADE_APPLICATION = 'selfservice/CONFIRM_UPGRADE_APPLICATION';
export const CONFIRM_UPGRADE_APPLICATION_SUCCESS = 'selfservice/CONFIRM_UPGRADE_APPLICATION_SUCCESS';
export const CONFIRM_UPGRADE_APPLICATION_FAIL = 'selfservice/CONFIRM_UPGRADE_APPLICATION_FAIL';

// API GATEWAY
export const GET_ADDITIONAL_LOAN_QUESTIONS = 'selfservice/GET_ADDITIONAL_LOAN_QUESTIONS';
export const GET_ADDITIONAL_LOAN_QUESTIONS_SUCCESS = 'selfservice/GET_ADDITIONAL_LOAN_QUESTIONS_SUCCESS';
export const GET_ADDITIONAL_LOAN_QUESTIONS_FAIL = 'selfservice/GET_ADDITIONAL_LOAN_QUESTIONS_FAIL';
export const GET_API_GATEWAY_ACESS_TOKEN = 'selfservice/GET_API_GATEWAY_ACESS_TOKEN';
export const GET_API_GATEWAY_ACESS_TOKEN_SUCCESS = 'selfservice/GET_API_GATEWAY_ACESS_TOKEN_SUCCESS';
export const GET_API_GATEWAY_ACESS_TOKEN_FAIL = 'selfservice/GET_API_GATEWAY_ACESS_TOKEN_FAIL';
export const PATCH_ADDITIONAL_LOAN_QUESTIONS = 'selfservice/PATCH_ADDITIONAL_LOAN_QUESTIONS';
export const PATCH_ADDITIONAL_LOAN_QUESTIONS_SUCCESS = 'selfservice/PATCH_ADDITIONAL_LOAN_QUESTIONS_SUCCESS';
export const PATCH_ADDITIONAL_LOAN_QUESTIONS_FAIL = 'selfservice/PATCH_ADDITIONAL_LOAN_QUESTIONS_FAIL';

// configuration
export const PARTNER_IFRAME_MESSAGE_RECEIVED = 'integration/PARTNER_IFRAME_MESSAGE_RECEIVED';
export const IFRAME_MESSAGE_SENT = 'integration/IFRAME_MESSAGE_SENT';
export const IFRAME_MESSAGE_RECEIVED = 'integration/IFRAME_MESSAGE_RECEIVED';
export const PARTNER_IFRAME_CLOSE_USP = 'integration/PARTNER_IFRAME_CLOSE_USP';

// analytics
export const INIT_ANALYTICS_DATA = 'analytics/INIT_ANALYTICS_DATA';
export const TRACK_ANALYTICS_DATA = 'analytics/TRACK_ANALYTICS_DATA';

// legal agreements
export const HIDE_COOKIES_BAR = 'legalAgreements/HIDE_COOKIES_BAR';

// click2call
export const CLICK2CALL_TOGGLE = 'click2call/CLICK2CALL_TOGGLE';
export const CLICK2CALL = 'click2call/CLICK2CALL';
export const CLICK2CALL_SUCCESS = 'click2call/CLICK2CALL_SUCCESS';
export const CLICK2CALL_FAIL = 'click2call/CLICK2CALL_FAIL';
export const CLICK2CALL_SHOW_SUPPORT = 'click2call/CLICK2CALL_SHOW_SUPPORT';
export const CLICK2CALL_RESET = 'click2call/CLICK2CALL_RESET';

// MARKETING_CONSENTS
export const GET_MARKETING_CONSENTS = 'marketingConsents/GET_MARKETING_CONSENTS';
export const GET_MARKETING_CONSENTS_SUCCESS = 'marketingConsents/GET_MARKETING_CONSENTS_SUCCESS';
export const GET_MARKETING_CONSENTS_FAIL = 'marketingConsents/GET_MARKETING_CONSENTS_FAIL';
export const PUT_CONSENTS = 'marketingConsents/PUT_CONSENTS';
export const PUT_CONSENTS_SUCCESS = 'marketingConsents/PUT_CONSENTS_SUCCESS';
export const PUT_CONSENTS_FAIL = 'marketingConsents/PUT_CONSENTS_FAIL';

// communication with native MW application
export const MW_LOGOUT = 'MW/LOGOUT';
export const MW_RESUME_FLOW = 'MW/RESUME_FLOW';
export const MW_PIN_RESET = 'MW/PIN_RESET';
export const MW_BACK_BUTTON_CLICK = 'MW/BACK_BUTTON_CLICK';
export const MW_SEND_STATUS = 'MW/SEND_STATUS';
export const MW_PAY_INVOICE = 'MW/PAY_INVOICE';
export const MW_GO_BACK = 'MW/GO_BACK';
export const MW_GO_MAIN = 'MW/GO_MAIN';
export const MW_LOGIN = 'MW/LOGIN';

// technical actions
export const ACTION_SKIPPED = 'technical/ACTION_SKIPPED';
export const SET_LANDING_URL = 'technical/SET_LANDING_URL';

// confirmation
export const SMART_ID_APP_CONFIRM_START = 'confirm/SMART_ID_APP_CONFIRM_START';
export const SMART_ID_APP_CONFIRM_SUCCESS = 'confirm/SMART_ID_APP_CONFIRM_SUCCESS';
export const SMART_ID_APP_CONFIRM_FAIL = 'confirm/SMART_ID_APP_CONFIRM_FAIL';
export const SMART_ID_APP_CONFIRM_STATUS = 'confirm/SMART_ID_APP_CONFIRM_STATUS';
export const SMART_ID_APP_CONFIRM_STATUS_SUCCESS = 'confirm/SMART_ID_APP_CONFIRM_STATUS_SUCCESS';
export const SMART_ID_APP_CONFIRM_STATUS_FAIL = 'confirm/SMART_ID_APP_CONFIRM_STATUS_FAIL';
export const ONE_CENT_PAYMENT_STATUS_START = 'confirm/ONE_CENT_PAYMENT_STATUS_START';
export const ONE_CENT_PAYMENT_STATUS_SUCCESS = 'confirm/ONE_CENT_PAYMENT_STATUS_SUCCESS';
export const ONE_CENT_PAYMENT_STATUS_FAIL = 'confirm/ONE_CENT_PAYMENT_STATUS_FAIL';
export const RESET_REDIRECT_TO_CONFIRM = 'confirm/RESET_REDIRECT_TO_CONFIRM';

// nordigen
export const GET_NORDIGEN_CREDIT_APLICATION_ID = 'nordigen/GET_NORDIGEN_CREDIT_APLICATION_ID';
export const GET_NORDIGEN_CREDIT_APLICATION_ID_SUCCESS = 'nordigen/GET_NORDIGEN_CREDIT_APLICATION_ID_SUCCESS';
export const GET_NORDIGEN_CREDIT_APLICATION_ID_FAIL = 'nordigen/GET_NORDIGEN_CREDIT_APLICATION_ID_FAIL';
export const POST_NORDIGEN_STANDALONE_BANK = 'nordigen/POST_NORDIGEN_STANDALONE_BANK';
export const POST_NORDIGEN_STANDALONE_BANK_SUCCESS = 'nordigen/POST_NORDIGEN_STANDALONE_BANK_SUCCESS';
export const POST_NORDIGEN_STANDALONE_BANK_FAIL = 'nordigen/POST_NORDIGEN_STANDALONE_BANK_FAIL';
export const GET_NORDIGEN_STANDALONE_ACCOUNT = 'nordigen/GET_NORDIGEN_STANDALONE_ACCOUNT';
export const GET_NORDIGEN_STANDALONE_ACCOUNT_SUCCESS = 'nordigen/GET_NORDIGEN_STANDALONE_ACCOUNT_SUCCESS';
export const GET_NORDIGEN_STANDALONE_ACCOUNT_FAIL = 'nordigen/GET_NORDIGEN_STANDALONE_ACCOUNT_FAIL';

// provident scoring
export const PROVIDENT_SCORING_MX = 'provident/PROVIDENT_SCORING_MX';
export const PROVIDENT_SCORING_MX_SUCCESS = 'provident/PROVIDENT_SCORING_MX_SUCCESS';
export const PROVIDENT_SCORING_MX_FAIL = 'provident/PROVIDENT_SCORING_MX_FAIL';

// provident updated
export const PROVIDENT_UPDATE = 'provident-update/PROVIDENT_UPDATE';
export const PROVIDENT_UPDATE_SUCCESS = 'provident-update/PROVIDENT_UPDATE_SUCCESS';
export const PROVIDENT_UPDATE_FAIL = 'provident-update/PROVIDENT_UPDATE_FAIL';

// followup
export const GET_FOLLOWUP_QUESTIONS = 'followup/GET_FOLLOWUP_QUESTIONS';
export const GET_FOLLOWUP_QUESTIONS_SUCCESS = 'followup/GET_FOLLOWUP_QUESTIONS_SUCCESS';
export const GET_FOLLOWUP_QUESTIONS_FAIL = 'followup/GET_FOLLOWUP_QUESTIONS_FAIL';

export const PUT_FOLLOWUP_QUESTIONS = 'followup/PUT_FOLLOWUP_QUESTIONS';
export const PUT_FOLLOWUP_QUESTIONS_SUCCESS = 'followup/PUT_FOLLOWUP_QUESTIONS_SUCCESS';
export const PUT_FOLLOWUP_QUESTIONS_FAIL = 'followup/PUT_FOLLOWUP_QUESTIONS_FAIL';

// centerlink
export const GET_CENTERLINK_REPORTS_STATUS = 'cenerlink/GET_CENTERLINK_REPORTS_STATUS';
export const GET_CENTERLINK_REPORTS_STATUS_SUCCESS = 'cenerlink/GET_CENTERLINK_REPORTS_STATUS_SUCCESS';
export const GET_CENTERLINK_REPORTS_STATUS_FAIL = 'cenerlink/GET_CENTERLINK_REPORTS_STATUS_FAIL';

// Consents
export const GET_CONSENTS = 'consents/GET_CONSENTS';
export const GET_CONSENTS_SUCCESS = 'consents/GET_CONSENTS_SUCCESS';
export const GET_CONSENTS_FAIL = 'consents/GET_CONSENTS_FAIL';

// Impersonation Lead Market
export const GET_LEADMARKET_IMPERSONATION = 'leadmarketImpersonation/GET_LEADMARKET_IMPERSONATION';
export const GET_LEADMARKET_IMPERSONATION_SUCCESS = 'leadmarketImpersonation/GET_LEADMARKET_IMPERSONATION_SUCCESS';
export const GET_LEADMARKET_IMPERSONATION_FAIL = 'leadmarketImpersonation/GET_LEADMARKET_IMPERSONATION_FAIL';
